import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import MenuVariaveis from '../../MenuVariaveis';

function ImageMenu(props) {
  const { item, doUpdateItem } = props;

  const { i18n } = useTranslation();

  const [titleImage, setTitleImage] = useState(item?.fileTitle || '');
  const [textImage, setTextImage] = useState(item?.fileDescription || '');

  useEffect(() => {
    setTitleImage(item?.fileTitle || '');
    setTextImage(item?.fileDescription || '');
    console.log(item);
  }, [item]);

  const changeTitle = (e) => {
    const { value } = e.target;
    setTitleImage(value);
    doUpdateItem({ fileTitle: value });
  };
  const changeText = (e) => {
    const { value } = e.target;
    setTextImage(value);
    doUpdateItem({ fileDescription: value });
  };

  const handleSelectVariavel = (value, variavel) => {
    const valor = `${value} ${variavel}`;
    setTextImage(valor);
    doUpdateItem({ fileDescription: valor });
  };

  return (
    <div>
      <div className="common-form-group">
        <label>{i18n.t('Titulo da imagem')}</label>
        <input
          type="text"
          id="title-image"
          name="titleimage"
          className="form-control mt-1 col-md-12"
          value={titleImage}
          onChange={(e) => changeTitle(e)}
        />
      </div>
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(textImage, `$$${variavel}$$`)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-text-image`}
        isTooltip
      >
        <div className="common-form-group">
          <label>{i18n.t('Texto alternativo')}</label>
          <img
            className="right-button"
            src={require('../../../assets/images/expandir.svg')}
            data-toggle="modal"
            data-target="#modal-code-editor"
            alt=""
          />
          <textarea
            className="form-control mt-1"
            value={textImage}
            id="text-image"
            name="text"
            onChange={(e) => changeText(e)}
          />
        </div>
      </MenuVariaveis>
    </div>
  );
}

export default ImageMenu;
